import classNames from 'classnames/bind';
import React, { useContext } from 'react';
import { UserContext } from '../../context/UserContext';
import styles from './UserAvatar.module.scss';

const cx = classNames.bind(styles);

const UserAvatar = (): React.ReactElement => {
  const { userFirstName, userLastName } = useContext(UserContext);

  const firstInitial = userFirstName ? userFirstName[0].toUpperCase() : '';
  const lastInitial = userLastName ? userLastName[0].toUpperCase() : '';

  return <div className={cx('body')}>{`${firstInitial}${lastInitial}`}</div>;
};

export default UserAvatar;
